import { render, staticRenderFns } from "./scheduleKmtcPremiumPop.vue?vue&type=template&id=15d4c809"
import script from "./scheduleKmtcPremiumPop.vue?vue&type=script&lang=js"
export * from "./scheduleKmtcPremiumPop.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/AzDevOps/myagent/_work/11/s/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15d4c809')) {
      api.createRecord('15d4c809', component.options)
    } else {
      api.reload('15d4c809', component.options)
    }
    module.hot.accept("./scheduleKmtcPremiumPop.vue?vue&type=template&id=15d4c809", function () {
      api.rerender('15d4c809', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/schedule/popup/scheduleKmtcPremiumPop.vue"
export default component.exports